<template>
	<v-form-group :label="label" :id="elementId" :cols="cols">
		<select class="form-control" :id="elementId" :multiple="multiple !== null" @input="updateModel" ref="select">
			<option
				v-for="o in options"
				:value="o"
				:selected="multiple !== null ? value.indexOf(o) !== -1 : JSON.stringify(o) === JSON.stringify(value)"
				v-html="o[optionText] ? o[optionText] : o"
			></option>
		</select>
	</v-form-group>
</template>

<script>
	import Base from './base';
	import VFormGroup from './form-group';

	export default {
		extends: Base,

		components: { VFormGroup },

		props: {
			options: { default: () => [] },
			optionValue: { default: '' },
			optionText: { default: 'name' },
			multiple: { default: null }
		},

		watch: {
			options: {
				handler() {
					if (this.options.length) {
						let isEmpty = Object.values(this.value).every(item => item === '');

						if (isEmpty) {
							this.$emit('input', this.options[0]);
						}
					}
				},

				immediate: true
			}
		},

		methods: {
			updateModel($event) {
				let selectedOptions = [...$event.target.selectedOptions];
				let values = selectedOptions.map(option => {
					return option._value !== undefined ? option._value : option.value;
				});

				if (this.multiple !== null) {
					this.$emit('input', values);
				} else {
					this.$emit('input', values[0]);
				}
			}
		}
	};
</script>


// WEBPACK FOOTER //
// select.vue?ec290f7c